const appConfig = {
    apiPrefix: '/api',
    // unAuthenticatedEntryPath: '/sign-in',
    unAuthenticatedEntryPath: '/',
    authenticatedEntryPath: '/home',
    tourPath: '/',
    enableMock: false,
};

export default appConfig;
